import React from 'react';
import { Box, Button, Typography } from '@mui/material';

import EntryView from './content/EntryView';
import ContentView from './content/ContentView';

function MainView({content, editMode}) {
	console.log("MainView()");

	const [blockReason, setBlockReason] = React.useState(content.blockReason);
	const [isLocked, setIsLocked] = React.useState(content.isLocked);

	async function handlePassword(password) {
		let unlockResult = await content.unlock({ password: password });
		if (unlockResult) {
			setBlockReason(unlockResult.blockReason);
			setIsLocked(unlockResult.isLocked);
		}
	}

	function handleRetry() {
		setBlockReason(undefined);
		setIsLocked(true);
	}

	function getPasswordNotMatchedPage() {
		const TITLE_STYLE = {
			fontFamily:'노토산스 Bold',
			fontSize:`${18/360 * 100}vw`,
			color:'black',
			marginBottom: `${20/360 * 100}vw`,
		};
		const BODY_STYLE = {
			fontFamily:'노토산스 Regular',
			fontSize:`${14/360 * 100}vw`,
			color:'black',
		};

		return (
			<Box
				display="flex"
				flexDirection='column'
				justifyContent='center'
				alignItems='center'
				sx={{ width:'100vw', height:'100vh' }}
			>
				<Typography sx={TITLE_STYLE}>
					컨텐츠 접근 오류
				</Typography>
				<Typography sx={BODY_STYLE}>
					비밀번호가 일치하지 않습니다.
				</Typography>
				<Button
					variant="outlined"
					sx={{
						marginTop: `${20/360 * 100}vw`,
						bgcolor: '#6cadff',
						border: `${1/360 * 100}vw solid #6cadff`,
						borderRadius: `${15/360 * 100}vw`,
						width: `${107/360 * 100}vw`,
						height: `${35/360 * 100}vw`,
					}}
					onClick={handleRetry}
				>
					<Typography
						fontFamily='노토산스 Medium'
						fontSize={`${14/360 * 100}vw`}
						color='#ffffff'
						sx={{margin:'-10px'}}
					>
						재시도	
					</Typography>
				</Button>
			</Box>
		);
	}

	function getContentBlockedPage() {
		const TITLE_STYLE = {
			fontFamily:'노토산스 Bold',
			fontSize:`${18/360 * 100}vw`,
			color:'black',
			marginBottom: `${20/360 * 100}vw`,
		};
		const BODY_STYLE = {
			fontFamily:'노토산스 Regular',
			fontSize:`${14/360 * 100}vw`,
			color:'black',
			marginBottom: `${5/360 * 100}vw`,
		};
		const BOTTOM_STYLE = {
			fontFamily:'노토산스 Regular',
			fontSize:`${12/360 * 100}vw`,
			color:'black',
			marginTop: `${10/360 * 100}vw`,
		};

		return (
			<Box
				display="flex"
				flexDirection='column'
				justifyContent='center'
				alignItems='center'
				sx={{ width:'100vw', height:'100vh' }}
			>
				<Typography sx={TITLE_STYLE}>
					컨텐츠 접근 오류
				</Typography>
				<Typography sx={BODY_STYLE}>
					컨텐츠 소유자의 정책에 따라
				</Typography>
				<Typography sx={BODY_STYLE}>
					지금은 컨텐츠 접근이 제한됩니다.
				</Typography>
				<Typography sx={BODY_STYLE}>
					나중에 다시 시도해 주세요.
				</Typography>
				<Typography sx={BOTTOM_STYLE}>
					{`(상세원인: ${blockReason} )`}
				</Typography>
			</Box>
		);
	}

	if (blockReason) {
		if (blockReason === 'PASSWORD_NOT_MATCHED') {
			return getPasswordNotMatchedPage();
		}
		else {
			return getContentBlockedPage();
		}
	}

	if (isLocked) {
		return (<EntryView onPassword={handlePassword}/>);
	}

	return (<ContentView content={content} editMode={editMode}/>);
}

export default MainView;
